import React from 'react'

export default function useFormat() {
  const formatPrice = (price) => {
    if (price) {
      return new Intl.NumberFormat('da-dk', {
        style: 'currency',
        currency: 'DKK',
        maximumFractionDigits: 0
      }).format(price)
    }

    return ''
  }

  const formatMonthsToYears = (months, postFix = 'år') => {
    if (months) {
      const years = months / 12
      const roundedYears = parseFloat(Number(years).toFixed(2))
      return postFix ? `${roundedYears} ${postFix}` : roundedYears
    }

    return ''
  }

  const formatMonths = (months, postFix = 'mdr.') => {
    if (months) {
      return postFix ? `${months} ${postFix}` : months
    }

    return ''
  }

  const formatPercentWithDecimal = (decimalNumber) => {
    if (decimalNumber) {
      const decimalNumberFixed = decimalNumber.toFixed(2)
      return `${decimalNumberFixed}%`.replace('.', ',')
    }

    return ''
  }

  return {
    formatPrice,
    formatMonths,
    formatMonthsToYears,
    formatPercentWithDecimal
  }
}
